import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="bg-gray-50 min-h-screen py-16 px-6">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-2xl p-8 md:p-12">
        
        {/* Header */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Privacy Policy
        </h1>
        <p className="text-gray-500 mb-8">
          Effective Date: 25 Dec 2024
        </p>

        <p className="text-gray-700 mb-8">
          At <span className="font-semibold">codecups.in</span>, we value your
          privacy and are committed to protecting your personal information.
          This Privacy Policy explains how we collect, use, and safeguard your
          information when you interact with our website, advertisements, or
          services.
        </p>

        {/* Section 1 */}
        <Section title="1. Information We Collect">
          <ul className="list-disc pl-6 space-y-2">
            <li>Full Name</li>
            <li>Company / Brand Name</li>
            <li>Email Address</li>
            <li>Phone Number</li>
            <li>Business Information</li>
            <li>Budget and Service Requirements</li>
          </ul>
          <p className="mt-4">
            We only collect information that is necessary to provide our
            services.
          </p>
        </Section>

        {/* Section 2 */}
        <Section title="2. How We Use Your Information">
          <ul className="list-disc pl-6 space-y-2">
            <li>Contact you regarding your inquiry</li>
            <li>Understand your business needs</li>
            <li>Provide consultation and service details</li>
            <li>Improve our services and communication</li>
            <li>Share relevant updates related to our services</li>
          </ul>
          <p className="mt-4">
            We do not sell, rent, or trade your personal information.
          </p>
        </Section>

        {/* Section 3 */}
        <Section title="3. Data Protection">
          <p>
            We take reasonable steps to protect your personal information from
            unauthorized access, misuse, or disclosure.
          </p>
          <p className="mt-4">
            Your information is stored securely and only accessible to
            authorized team members.
          </p>
        </Section>

        {/* Section 4 */}
        <Section title="4. Sharing of Information">
          <p>
            We do not share your personal information with third parties except:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4">
            <li>When required by law</li>
            <li>
              When necessary to provide services (e.g., advertising platforms
              or tools used for campaign management)
            </li>
          </ul>
        </Section>

        {/* Section 5 */}
        <Section title="5. Cookies and Tracking">
          <p>
            Our website may use cookies or tracking tools to improve user
            experience and analyze website performance. These tools do not
            collect sensitive personal information.
          </p>
        </Section>

        {/* Section 6 */}
        <Section title="6. Your Rights">
          <ul className="list-disc pl-6 space-y-2">
            <li>Request access to your personal information</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your data</li>
          </ul>
          <p className="mt-4">
            To make such requests, contact us at:
          </p>
          <p className="mt-2 font-medium">
            📧 info@codecups.in
          </p>
        </Section>

        {/* Section 7 */}
        <Section title="7. Updates to This Policy">
          <p>
            We may update this Privacy Policy from time to time. Any updates
            will be posted on this page with a revised effective date.
          </p>
        </Section>

        {/* Section 8 */}
        <Section title="8. Contact Us">
          <p>If you have any questions about this Privacy Policy, please contact:</p>
          <div className="mt-4 space-y-2">
            <p className="font-semibold">codecups.in</p>
            <p>📧 info@codecups.in</p>
            <p>📞 +91 8077012855</p>
          </div>
        </Section>

      </div>
    </div>
  );
}

/* Reusable Section Component */
function Section({ title, children }) {
  return (
    <div className="mb-10">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        {title}
      </h2>
      <div className="text-gray-700 leading-relaxed space-y-3">
        {children}
      </div>
    </div>
  );
}